import { render, staticRenderFns } from "./ServiceRequest.vue?vue&type=template&id=5c53f4b4&scoped=true"
import script from "./ServiceRequest.vue?vue&type=script&lang=js"
export * from "./ServiceRequest.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequest.vue?vue&type=style&index=0&id=5c53f4b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c53f4b4",
  null
  
)

export default component.exports